import { Alert, Button, Modal, Table } from "antd"
import { formatDateTimeISO } from "../../../../utils/date";
import { useGetProductPlanUploadJobsQuery } from "../../../../api/usim/uploads/products/productPlansApi";
import { PlanUploadJobItem } from "../../../../api/usim/uploads/products/planUploadJobItem";
import { useGetUsimMappingUploadJobsQuery } from "../../../../api/usim/mappings/UsimMappingApi";

const columns = [
  {
    title: "Job ID",
    dataIndex: "Id",
    key: "Id",
  },
  {
    title: "Processed Started At",
    dataIndex: "UpdatedAt",
    key: "UpdatedAt",
    render: (v: string) => v ? formatDateTimeISO(v) : "-",
     sorter: (a: PlanUploadJobItem, b: PlanUploadJobItem) => (a.UpdatedAt || "").localeCompare(b.UpdatedAt || ""),
  },
  {
    title: "Processed Finished At",
    dataIndex: "ProcessedFinishedAt",
    key: "ProcessedFinishedAt",
    render: (v: string) => v ? formatDateTimeISO(v) : "-"
    // sorter: (a: PlanUploadJobItem, b: PlanUploadJobItem) => a.ProcessedFinishedAt.localeCompare(b.ProcessedFinishedAt),
  },
  {
    title: "Row Count (if successful)",
    dataIndex: "IngestedRows",
    key: "IngestedRows"
  },
  {
    title: "Error Count",
    dataIndex: "ErrorRows",
    key: "ErrorRows",
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
  },
  {
    title: "Action",
    key: "action",
    render: (_: any, obj: PlanUploadJobItem) => {
      function onClickViewErr() {
        Modal.confirm({
          content: obj.Errors!!.map(err => <li>{err}</li>),
          width: 800
        })
      }
      return (
        <Button
          disabled={obj.Errors == null}
          onClick={onClickViewErr}
        >
          View Errors
        </Button>
      )
    }
  }

]

export default function UploadJobTable() {
  const { data, error, isFetching, refetch } = useGetUsimMappingUploadJobsQuery();

  const sData = data?.toSorted((b,a) =>
    a.UpdatedAt?.localeCompare(b.UpdatedAt || ""));

  return (
    <>
    <Button onClick={refetch} type="primary">Reload</Button>
    { error && <Alert type="error" message="Error loading data" /> }
    <Table
    rowKey={"Id"}
      loading={isFetching}
      dataSource={sData}
      columns={columns}
    />
    </>
  )
}
